import { isDomainWithProtocol } from '@/utils/helper/DomainHelper'

/**
 * 判断字符串 是否为空
 * @param str
 * @returns {boolean}
 */
function isEmpty(str) {
  if (str === null || str === undefined || str === '') {
    return true
  }
  return false
}

/**
 * 校验手机号（严格校验）
 * //移动号段：134 135 136 137 138 139 147 148 150 151 152 157 158 159  165 172 178 182 183 184 187 188 195 198
 * // 联通号段：130 131 132 145 146 155 156 166 167 171 175 176 185 186
 * // 电信号段：133 149 153 173 174 177 180 181 189  191  199
 * // 虚拟运营商:170
 * 分组如下
 * //130 131 132 133 134 135 136 137 138 139
 * //145 146 147 148 149
 * //150 151 152 153 155 156 157 158 159
 * // 165 166 167
 * //170  171  172 173 174  175 176 177 178
 * //180 181 182 183 184 185 186 187 188 189
 * // 191  195  198 199
 * @param phone
 * @returns {boolean}
 */
function isPhoneNumber(phone) {
  //手机号正则
  if (/^1[38][0-9]{9}$/.test(phone)) {//校验//130 131 132 133 134 135 136 137 138 139  180 181 182 183 184 185 186 187 188 189号段
    return true
  }
  if (/^14[56789][0-9]{8}$/.test(phone)) {//校验14开头的号段
    return true
  }
  if (/^15[012356789][0-9]{8}$/.test(phone)) {//校验 1//150 151 152 153 155 156 157 158 159 开头的号段
    return true
  }
  if (/^16[567][0-9]{8}$/.test(phone)) {//校验 // 165 166 167 开头的号段
    return true
  }
  if (/^17[012345678][0-9]{8}$/.test(phone)) {//校验 //170  171  172 173 174  175 176 177 178 开头的号段
    return true
  }
  if (/^19[1589][0-9]{8}$/.test(phone)) {//校验// 191  195  198 199 开头的号段
    return true
  }
  return false
}

/**
 * 简化版本 - 主要用于正数校验，可选是否包含0
 */
function validatePositiveNumber(value, includeZero = false, maxDecimals = 2) {
  if (value === null || value === undefined || value === '') {
    return false
  }

  const strValue = String(value)

  // 构建正则表达式
  const pattern = includeZero
    ? `^\\d+(\\.\\d{1,${maxDecimals}})?$|^0(\\.0{1,${maxDecimals}})?$`
    : `^[1-9]\\d*(\\.\\d{1,${maxDecimals}})?$|^0\\.\\d{1,${maxDecimals}}$`

  const regex = new RegExp(pattern)

  if (!regex.test(strValue)) {
    return false
  }

  const numValue = parseFloat(strValue)
  return includeZero ? numValue >= 0 : numValue > 0
}

//校验辅助工具
export default class ValidatorHelper {
  /**
   * /校验手机号码输入是否有效
   * @param mobile
   * @returns {boolean}
   */
  static validateMobile(mobile) {
    if (!isPhoneNumber(mobile)) {
      return false
    }
    return true
  }

  /**
   * 是否是组织机构代码
   * @param code
   * @returns {*|boolean}
   */
  static isOrganizationCode(code) {
    return /[0-9A-HJ-NPQRTUWXY]{8}-[0-9A-HJ-NPQRTUWXY]/g.test(code)
  }

  /**
   * 18位的统一信用代码
   * @param code
   * @returns {*|boolean}
   */
  static isUnifiedCreditCode(code) {
    return /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/.test(code)
  }

  /**
   * 判断是否是邮件
   * @param email
   * @returns {*|boolean}
   */
  static isEmail(email) {
    if (email) {
      return /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(email)
    }
    return false
  }

  static crateRuleItem(required, message) {
    return { required: required, message: message, trigger: 'change,blur' }
  }

  static createEmailRule(message, validatorErrorMsg) {
    const showMsg = message ? message : '请输入邮箱地址'
    const showErrorMsg = validatorErrorMsg ? validatorErrorMsg : '邮箱地址格式有误'

    function handleEmail(rule, value, callback) {
      if (!value) {
        callback(new Error(showMsg))
      } else if (ValidatorHelper.isEmail(value)) {
        callback()
      } else {
        callback(new Error(showErrorMsg))
      }
    }

    return [
      { required: true, message: showMsg, trigger: 'change,blur' },
      { required: true, validator: handleEmail }
    ]
  }

  static createMobileRule(required, message, validatorErrorMsg) {
    const showMsg = message ? message : '请输入手机号'
    const showErrorMsg = validatorErrorMsg ? validatorErrorMsg : '手机号码格式有误'

    function handlePhone(rule, value, callback) {
      if (!value && required) {
        callback(new Error(showMsg))
      } else if (value && !ValidatorHelper.validateMobile(value)) {
        callback(new Error(showErrorMsg))
      } else {
        callback()
      }
    }

    return [
      { required: required, message: showMsg, trigger: 'change,blur' },
      { required: required, validator: handlePhone }
    ]
  }

  static createDomainRule(required, message, validatorErrorMsg) {
    const showMsg = message ? message : '请输入域名'
    const showErrorMsg = validatorErrorMsg ? validatorErrorMsg : '域名格式有误'

    function handleDomain(rule, value, callback) {
      if (!value && required) {
        callback(new Error(showMsg))
      } else if (value && !isDomainWithProtocol(value)) {
        callback(new Error(showErrorMsg))
      } else {
        callback()
      }
    }

    return [
      { required: required, message: showMsg, trigger: 'change,blur' },
      { required: required, validator: handleDomain }
    ]
  }

  /**
   * 创建数字校验规则
   * @param required 是否必传
   * @param message 普通信息提示
   * @param validatorErrorMsg 错误信息提示
   * @param includeZero 是否包含 0
   * @param maxDecimals 小数位数
   * @returns {[{required: *, message: *|string, trigger: string},{required: *, validator: handleDomain}]}
   */
  static createPositiveNumberRule(required, message, validatorErrorMsg, includeZero = false, maxDecimals = 2) {
    const showMsg = message ? message : '请输入'
    const showErrorMsg = validatorErrorMsg ? validatorErrorMsg : '格式有误'

    function handleDomain(rule, value, callback) {
      if (!value && required) {
        callback(new Error(showMsg))
      } else if (value && !validatePositiveNumber(value, includeZero, maxDecimals)) {
        callback(new Error(showErrorMsg))
      } else {
        callback()
      }
    }

    return [
      { required: required, message: showMsg, trigger: 'change,blur' },
      { required: required, validator: handleDomain }
    ]
  }
}